module.exports = __webpack_public_path__ + "static/img/1.ca9e880.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/juhua/R507/1.jpg
// module id = rYsD
// module chunks = 1